function addTargetBlankToExternalLinks(root = document) {
  const links = root.querySelectorAll('a[href]');

  links.forEach((link) => {
    const href = link.getAttribute('href');

    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return;
    }

    let url;

    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return;
    }

    const isHttpLink = url.protocol === 'http:' || url.protocol === 'https:';
    const isExternal = url.origin !== window.location.origin;

    if (!isHttpLink || !isExternal) {
      return;
    }

    link.setAttribute('target', '_blank');

    const relParts = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    relParts.add('noopener');
    relParts.add('noreferrer');
    link.setAttribute('rel', Array.from(relParts).join(' '));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => addTargetBlankToExternalLinks());
} else {
  addTargetBlankToExternalLinks();
}


document.addEventListener('DOMContentLoaded', () => {
  const pageSlug = window.location.pathname.split('/').pop();
  document.body.classList.add(pageSlug);

  function updateLaddersFilterLabelOnMobile() {
    const mobileQuery = window.matchMedia('(max-width: 767px)');
  
    if (!mobileQuery.matches) return;

    const triggerLink = document.querySelector('body.faq .faq-nav a[href="#section-ladders-test-kits-thermometers-vac-heads"]');
  
    if (!triggerLink) return;
  
    const textSpan = triggerLink.querySelector('.collection-list__filter-trigger-text');
    if (!textSpan) return;
  
    textSpan.innerHTML = 'Ladders, Test Kits,<br>Thermometers, Vac Heads';
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLaddersFilterLabelOnMobile);
  } else {
    updateLaddersFilterLabelOnMobile();
  }
});